import {useRef} from "react";

/**
 * Clé qui n'avance qu'à une VRAIE bascule d'établissement (un id connu remplacé
 * par un autre). Indexer directement sur l'id remonterait chaque page au
 * chargement, au passage de null à l'établissement, et doublerait ses requêtes.
 */
export function useFacilitySwitchKey(facilityId: number | null | undefined): number {
    const state = useRef<{ id: number | null; generation: number }>({id: null, generation: 0});

    if (facilityId != null && facilityId !== state.current.id) {
        if (state.current.id !== null) {
            state.current.generation += 1;
        }
        state.current.id = facilityId;
    }

    return state.current.generation;
}
